/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

import * as constants from '../constants'

export const allowedList = Object.values(constants)
